const SUPPORTED_ZERO_DECIMAL_CURRENCIES = [
	'BIF',
	'CLP',
	'DJF',
	'GNF',
	'JPY',
	'KMF',
	'KRW',
	'MGA',
	'PYG',
	'RWF',
	'UGX',
	'VND',
	'VUV',
	'XAF',
	'XOF',
	'XPF',
];

/**
 * Formats a WC amount to an amount expected by Square. WC blocks amounts are
 * formatted as the smallest unit(Ex: cents for USD) but square expects dollars.
 *
 * @param amount - The amount to format.
 * @param tax - The tax amount to add to the total.
 * @param currency - The currency code.
 * @param includeTax - Whether prices are displayed including tax.
 *
 * @returns The formatted amount as a string expected by Square.
 */
function formatAmount(amount: string, tax: string, currency: string, includeTax = false): string {
	let parsedAmount = Number.parseInt(amount);

	const parsedTax = Number.parseInt(tax);
	if (includeTax) {
		parsedAmount += parsedTax;
	}

	if (!SUPPORTED_ZERO_DECIMAL_CURRENCIES.includes(currency)) {
		parsedAmount /= 100;
	}

	return parsedAmount.toFixed(2);
}

export {
	formatAmount,
};
